export default "__VITE_ASSET__BGopLXqg__"